import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import PanelHeader from '../common/cards/PanelHeader';
import policiesQuotesIcon from '../../images/icons/policy.svg';
import policiesQuotesActions from '../../actions/policiesQuotes.actions';
import PoliciesQuotesDispatch from '../../contexts/policiesQuotes.dispatch';
import closeIcon from '../../images/icons/xs.svg';
import PoliciesQuotesPanelCard from '../common/cards/PoliciesQuotesPanelCard';
import ActionsPanelDispatch from '../../contexts/actionsPanelDispatch';
import actionsPanelActions from '../../actions/actionsPanel.actions';

import style from './PoliciesQuotesPanel.module.css';

const PoliciesQuotesPanel = React.memo(({ clientId, panelState }) => {
  const [cards, setCards] = useState([]);
  const policiesQuotesDispatch = useContext(PoliciesQuotesDispatch);

  const actionsPanelDispatch = useContext(ActionsPanelDispatch);

  const handleClosePoliciesFilter = event => {
    event.preventDefault();

    policiesQuotesDispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_FILTER_CHANGE_SUCCESS,
      policies: !panelState.policies,
      quotes: panelState.quotes,
    });
  };

  const handleCloseQuotesFilter = event => {
    event.preventDefault();

    policiesQuotesDispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_FILTER_CHANGE_SUCCESS,
      policies: panelState.policies,
      quotes: !panelState.quotes,
    });
  };

  useEffect(() => {
    const handleSuccess = ({ data }) => {
      setCards(data.Cards);

      const policies = data.Cards.some(item => {
        return item.Data.IsPolicy;
      });

      const proposals = data.Cards.some(item => {
        return item.Data.IsProposed;
      });

      actionsPanelDispatch({
        type: actionsPanelActions.UPDATE_ACTIONS_PANEL_REQUEST,
        policies,
        proposals,
      });
    };

    axios
      .get(`${process.env.REACT_APP_BASE_URL}panels/policiesquotes/${clientId}`)
      .then(handleSuccess);
  }, [actionsPanelDispatch, clientId, panelState.bindRequestSent]);

  return (
    <section className={style.main}>
      <PanelHeader
        policiesQuotes
        icon={policiesQuotesIcon}
        title="POLICIES/QUOTES"
        filterState={panelState}
      />
      <div className={style.policiesQuotesFilter}>
        {panelState.policies && (
          <div className={style.filterItem}>
            Policies
            <button
              className={style.closeBtn}
              type="button"
              onClick={handleClosePoliciesFilter}
            >
              <img src={closeIcon} alt="" />
            </button>
          </div>
        )}
        {panelState.quotes && (
          <div className={style.filterItem}>
            Quotes
            <button
              className={style.closeBtn}
              type="button"
              href="#"
              onClick={handleCloseQuotesFilter}
            >
              <img src={closeIcon} alt="" />
            </button>
          </div>
        )}
      </div>
      {cards.map(item => {
        if (panelState.policies && panelState.quotes) {
          return (
            <PoliciesQuotesPanelCard
              key={item.Data.PolicyQuoteId}
              viewingDetails={item.Data.PolicyQuoteId === panelState.id}
              item={item}
            />
          );
        }
        if (panelState.policies && item.Data.IsPolicy) {
          return (
            <PoliciesQuotesPanelCard
              key={item.Data.PolicyQuoteId}
              viewingDetails={item.Data.PolicyQuoteId === panelState.id}
              item={item}
            />
          );
        }

        if (panelState.quotes && !item.Data.IsPolicy) {
          return (
            <PoliciesQuotesPanelCard
              viewingDetails={item.Data.PolicyQuoteId === panelState.id}
              item={item}
            />
          );
        }

        return null;
      })}
    </section>
  );
});

PoliciesQuotesPanel.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default PoliciesQuotesPanel;
